(function () {
  function init(root) {
    if (root.__lt) return; root.__lt = true;
    var cfgEl = root.querySelector('[data-config]');
    if (!cfgEl) return;
    var cfg = JSON.parse(cfgEl.textContent);
    var order = ['nodrawers'].concat(cfg.attachments.map(function (a) { return a.key; }));
    var on = {}; // start with nothing selected
    var qty = {}; var MAXQ = 6;
    function q(k) { return on[k] ? Math.max(1, qty[k] || 1) : 0; }
    var MULTI = ['pocket', 'dock', 'shelf'];
    function multiTotal(except) { return MULTI.reduce(function (t, k) { return t + (k === except ? 0 : q(k)); }, 0); }
    // Pockets, Docks and Shelves share the Frame's 6 spots; accessories just have a sensible per-item cap
    var ACCMAX = 10;
    function cap(k) { return MULTI.indexOf(k) > -1 ? MAXQ - multiTotal(k) : ACCMAX; }
    var hasDrawers = cfg.attachments.some(function (a) { return a.key === 'drawers'; });
    function photoKeys(chosen) {
      var ks = chosen.map(function (a) { return a.key; }).filter(function (k) { return k !== 'drawers'; });
      if (hasDrawers && !on.drawers) ks.unshift('nodrawers');
      return ks;
    }
    var fmt;
    try { fmt = new Intl.NumberFormat(cfg.locale || undefined, { style: 'currency', currency: cfg.currency || 'USD', minimumFractionDigits: 0, maximumFractionDigits: 2 }); } catch (e) { fmt = null; }
    function money(cents) { var v = cents / 100; return fmt ? fmt.format(v) : '$' + v.toFixed(v % 1 ? 2 : 0); }

    // combination photos, keyed in attachment order
    var shots = {};
    root.querySelectorAll('[data-shot]').forEach(function (img) {
      var raw = img.getAttribute('data-shot');
      var key = raw ? normalize(raw.split('+')) : '';
      shots[key] = img;
    });
    function normalize(keys) {
      return keys.map(function (k) { return k.trim().toLowerCase(); }).filter(Boolean)
        .sort(function (a, b) { return order.indexOf(a) - order.indexOf(b); }).join('+');
    }

    // photo swap without a flash: the picture with more pieces sits on top while it fades,
    // the other stays fully visible underneath, so the shared Frame never dims.
    var curShot = root.querySelector('.lt-shot.is-on'), curCount = 0, swapTimer = 0, swapToken = 0;
    function ready(img) { return img.complete && img.naturalWidth > 0; }
    function cleanShots() { Object.keys(shots).forEach(function (k) { shots[k].classList.remove('is-hold', 'is-snap', 'is-leave'); }); }
    function swapShot(next, count, alt) {
      next.setAttribute('alt', alt);
      if (next === curShot) { curCount = count; return; }
      var prev = curShot, adding = count >= curCount, token = ++swapToken;
      curShot = next; curCount = count;
      next.loading = 'eager';
      function go() {
        if (token !== swapToken) return;
        clearTimeout(swapTimer); cleanShots();
        Object.keys(shots).forEach(function (k) { var im = shots[k]; if (im !== next && im !== prev) { im.classList.remove('is-on'); im.setAttribute('alt', ''); } });
        if (!prev) { next.classList.add('is-on'); return; }
        prev.setAttribute('alt', '');
        if (adding) { prev.classList.remove('is-on'); prev.classList.add('is-hold'); next.classList.add('is-on'); }
        else { next.classList.add('is-on', 'is-snap'); prev.classList.remove('is-on'); prev.classList.add('is-leave'); }
        swapTimer = setTimeout(cleanShots, 500);
      }
      if (ready(next) || !prev) go();
      else {
        var fired = false, done = function () { if (fired) return; fired = true; next.removeEventListener('load', done); next.removeEventListener('error', done); go(); };
        next.addEventListener('load', done); next.addEventListener('error', done);
        if (next.decode) next.decode().then(done, function () {});
      }
    }
    function preloadNext(chosen) {
      // warm up every picture one tap away
      var cur = chosen.map(function (a) { return a.key; });
      cfg.attachments.forEach(function (a) {
        var ks = cur.indexOf(a.key) > -1 ? cur.filter(function (k) { return k !== a.key; }) : cur.concat(a.key);
        var fake = ks.map(function (k) { return { key: k }; });
        var saved = on.drawers; on.drawers = ks.indexOf('drawers') > -1 || !hasDrawers ? true : false;
        var img = shots[normalize(photoKeys(fake))]; on.drawers = saved;
        if (img && img.loading !== 'eager') img.loading = 'eager';
      });
    }
    // the whole row is clickable: price / checkbox side toggles too (quantity buttons keep their own job)
    root.addEventListener('click', function (e) {
      var side = e.target.closest('.lt-row__side');
      if (!side || e.target.closest('button')) return;
      var main = side.parentNode.querySelector('.lt-row__main');
      if (main) main.click();
    });
    // accessories in the summary: everything rolls into one "Silks" line, Playclips get their own line
    function accGroup(a) {
      var t = ((a.group || '') + ' ' + (a.title || '')).toLowerCase();
      return t.indexOf('clip') > -1 ? 'Playclips' : 'Silks';
    }
    function accLines() {
      var groups = {}, order = ['Silks', 'Playclips'];
      (cfg.accessories || []).forEach(function (a) { var g = accGroup(a); if (order.indexOf(g) < 0) order.push(g); if (on[a.key]) { groups[g] = groups[g] || { n: 0, p: 0 }; groups[g].n += q(a.key); groups[g].p += a.price * q(a.key); } });
      if (!(cfg.accessories || []).length) return [];
      return order.filter(function (g) { return g === 'Silks' || g === 'Playclips' || groups[g]; }).map(function (g) {
        var x = groups[g]; return { t: g + (x && x.n > 1 ? ' × ' + x.n : ''), p: x ? x.p : 0, on: !!x };
      });
    }
    var pending = root.querySelector('[data-pending]');
    var summary = root.querySelector('[data-summary]');
    var total = root.querySelector('[data-total]');
    var addBtn = root.querySelector('[data-add]');
    var status = root.querySelector('[data-status]');
    var allBtn = root.querySelector('[data-toggle-all]');

    function render() {
      var chosen = cfg.attachments.filter(function (a) { return on[a.key]; });
      var key = normalize(photoKeys(chosen));
      var target = shots[key] || shots[''];
      swapShot(target, chosen.length, cfg.frame.title + (chosen.length ? ' with ' + chosen.map(function (a) { return a.title; }).join(', ') : ''));
      preloadNext(chosen);
      if (pending) pending.hidden = !(key && !shots[key]);

      root.querySelectorAll('[data-toggle]').forEach(function (b) {
        var k = b.getAttribute('data-toggle');
        b.setAttribute('aria-pressed', on[k] ? 'true' : 'false');
        if (b.classList.contains('lt-hot')) { var nm = (cfg.attachments.filter(function (x) { return x.key === k; })[0] || {}).title || k; b.setAttribute('aria-label', (on[k] ? 'Remove ' : 'Add ') + nm); }
        b.classList.toggle('is-on', !!on[k]);
        var w = b.closest('.lt-row'); if (w && w !== b) w.classList.toggle('is-on', !!on[k]);
        var sign = b.querySelector('[data-chip-sign]');
        if (sign) sign.textContent = on[k] ? '−' : '+';
      });

      var accs = (cfg.accessories || []).filter(function (a) { return on[a.key]; });
      var sum = (on.frame ? cfg.frame.price : 0) + chosen.reduce(function (t, a) { return t + a.price * q(a.key); }, 0) + accs.reduce(function (t, a) { return t + a.price * q(a.key); }, 0);
      var lines = [{ t: cfg.frame.title, p: cfg.frame.price, on: !!on.frame }].concat(cfg.attachments.map(function (a) { return { t: a.title + (q(a.key) > 1 ? ' × ' + q(a.key) : ''), p: a.price * (q(a.key) || 1), on: !!on[a.key] }; })).concat(accLines());
      summary.innerHTML = '';
      lines.forEach(function (l) {
        var row = document.createElement('div'); row.className = 'lt-cfg__line';
        var a = document.createElement('span'); a.textContent = l.t;
        var b = document.createElement('span'); b.textContent = l.on ? money(l.p) : '—'; if (!l.on) row.classList.add('is-off');
        row.appendChild(a); row.appendChild(b); summary.appendChild(row);
      });
      root.querySelectorAll('[data-qty]').forEach(function (box) {
        var k = box.getAttribute('data-qty'); box.hidden = !on[k];
        box.querySelector('[data-qty-n]').textContent = q(k);
        box.querySelector('[data-qty-inc]').disabled = q(k) >= cap(k);
      });
      total.textContent = money(sum);
      root.__sum = sum;
      var mt = root.querySelector('[data-mbar-total]'); if (mt) mt.textContent = money(sum);
      addBtn.textContent = 'Add to cart · ' + money(sum);
      if (allBtn) allBtn.textContent = chosen.length === cfg.attachments.length ? 'Clear all' : 'Add all';
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('button')) root.classList.add('is-touched');
    });
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-toggle]');
      if (t && root.contains(t)) { root.classList.add('is-touched'); }
      if (t && root.contains(t)) { var k = t.getAttribute('data-toggle'); if (MULTI.indexOf(k) > -1 && !on[k] && multiTotal(k) >= MAXQ) { status.textContent = 'The Frame holds up to 6 Pockets, Docks and Shelves in total.'; return; } on[k] = !on[k]; qty[k] = on[k] ? 1 : 0; status.textContent = ''; render(); }
    });
    root.querySelectorAll('[data-qty]').forEach(function (box) {
      var k = box.getAttribute('data-qty');
      box.querySelector('[data-qty-dec]').addEventListener('click', function () { var n = q(k) - 1; qty[k] = n; on[k] = n > 0; status.textContent = ''; render(); });
      box.querySelector('[data-qty-inc]').addEventListener('click', function () { qty[k] = Math.min(cap(k), q(k) + 1); status.textContent = ''; render(); });
    });
    if (allBtn) allBtn.addEventListener('click', function () {
      var all = cfg.attachments.every(function (a) { return on[a.key]; });
      cfg.attachments.forEach(function (a) { on[a.key] = !all; qty[a.key] = on[a.key] ? 1 : 0; });
      status.textContent = ''; render();
    });

    addBtn.addEventListener('click', function () {
      var items = [];
      if (on.frame) {
        if (!cfg.frame.variantId) { status.textContent = 'Choose the Frame product for this section in the theme editor.'; return; }
        if (!cfg.frame.available) { status.textContent = cfg.frame.title + ' is sold out right now.'; return; }
        items.push({ id: cfg.frame.variantId, quantity: 1 });
      }
      var missing = [];
      cfg.attachments.forEach(function (a) {
        if (!on[a.key]) return;
        if (a.variantId && a.available) items.push({ id: a.variantId, quantity: q(a.key) }); else missing.push(a.title);
      });
      (cfg.accessories || []).forEach(function (a) {
        if (!on[a.key]) return;
        if (a.variantId && a.available) items.push({ id: a.variantId, quantity: q(a.key) }); else missing.push(a.title);
      });
      if (!items.length) { status.textContent = missing.length ? missing.join(', ') + ' unavailable right now.' : 'Pick the Frame or an attachment first.'; return; }
      addBtn.disabled = true; status.textContent = 'Adding…';
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          status.innerHTML = '';
          status.appendChild(document.createTextNode('Added your setup to the cart. '));
          var a = document.createElement('a'); a.href = cfg.cartUrl; a.textContent = 'View cart'; status.appendChild(a);
          if (missing.length) status.appendChild(document.createTextNode(' (' + missing.join(', ') + ' unavailable)'));
          if (window.LT && LT.refreshCartCount) LT.refreshCartCount();
        })
        .catch(function (err) { status.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.'; })
        .finally(function () { addBtn.disabled = false; });
    });

    // play couch color
    var tint = root.querySelector('[data-tint]');
    var tintImg = root.querySelector('[data-tint-img]');
    var colorName = root.querySelector('[data-color-name]');
    var color = '';
    var tintCanvas = null, tintCache = {}, paintToken = 0;
    function paintTint(src, hex) {
      var token = ++paintToken;
      if (!tintCanvas) {
        tintCanvas = document.createElement('canvas');
        tintCanvas.className = 'lt-tint__canvas';
        tint.innerHTML = '';
        tint.appendChild(tintCanvas);
      }
      function draw(img) {
        if (token !== paintToken) return;
        var w = img.naturalWidth, h = img.naturalHeight;
        if (tintCanvas.width !== w) { tintCanvas.width = w; tintCanvas.height = h; }
        var ctx = tintCanvas.getContext('2d');
        ctx.globalCompositeOperation = 'source-over';
        ctx.clearRect(0, 0, w, h);
        ctx.drawImage(img, 0, 0);
        ctx.globalCompositeOperation = 'multiply';
        ctx.fillStyle = hex; ctx.fillRect(0, 0, w, h);
        ctx.globalCompositeOperation = 'destination-in';
        ctx.drawImage(img, 0, 0);
        ctx.globalCompositeOperation = 'source-over';
      }
      var img = tintCache[src];
      if (img && img.complete && img.naturalWidth) return draw(img);
      img = img || new Image();
      tintCache[src] = img;
      img.onload = function () { draw(img); };
      if (!img.src) img.src = src;
    }
    var baseRender = render;
    render = function () {
      baseRender();
      if (!tint) return;
      var chosen = cfg.attachments.filter(function (a) { return on[a.key]; });
      var key = normalize(chosen.map(function (a) { return a.key; }).filter(function (k) { return k !== 'drawers'; })) || 'frame';
      var src = (cfg.tints && (cfg.tints[key] || cfg.tints.frame)) || '';
      tint.hidden = !color;
      if (!color) return;
      paintTint(src, color);
    };
    var colorsBox = root.querySelector('.lt-colors__row');
    var colorsToggle = root.querySelector('[data-colors-toggle]');
    if (colorsToggle) colorsToggle.addEventListener('click', function () {
      var open = colorsBox.classList.toggle('is-open');
      colorsToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      colorsToggle.textContent = open ? 'Show fewer' : colorsToggle.getAttribute('data-more');
    });
    root.querySelectorAll('[data-color]').forEach(function (b) {
      b.addEventListener('click', function () {
        color = b.getAttribute('data-color');
        root.querySelectorAll('[data-color]').forEach(function (o) {
          var sel = o === b; o.setAttribute('aria-checked', sel ? 'true' : 'false');
          var sw = o.querySelector('.lt-sw'); if (sw) sw.classList.toggle('is-on', sel); o.classList.toggle('is-picked', sel);
        });
        if (colorName) colorName.textContent = b.getAttribute('data-name');
        render();
      });
    });
    // info dots over added pieces + pop-up card
    var pinsBox = root.querySelector('[data-pins]');
    var pop = root.querySelector('[data-pop]');
    var openPin = '';
    function att(k) { return cfg.attachments.filter(function (a) { return a.key === k; })[0]; }
    function closePop(focusPin) {
      if (!pop || !openPin) return;
      var b = pinsBox.querySelector('[data-pin="' + openPin + '"]');
      if (b) { b.setAttribute('aria-expanded', 'false'); b.classList.remove('is-open'); if (focusPin) b.focus(); }
      openPin = ''; pop.hidden = true; pop.innerHTML = '';
    }
    function showPop(k) {
      var a = att(k), b = pinsBox.querySelector('[data-pin="' + k + '"]');
      if (!a || !b) return;
      if (openPin) closePop(false);
      openPin = k;
      pop.innerHTML = '';
      var head = document.createElement('div'); head.className = 'lt-pop__head';
      if (a.thumb) { var im = document.createElement('img'); im.src = a.thumb; im.alt = ''; im.width = 44; im.height = 44; im.className = 'lt-pop__thumb'; head.appendChild(im); }
      var tt = document.createElement('div'); tt.className = 'lt-pop__titles';
      var h = document.createElement('strong'); h.className = 'lt-pop__title'; h.id = 'ltpop-' + k + '-' + Math.random().toString(36).slice(2, 7); h.textContent = a.title; tt.appendChild(h);
      if (a.price) { var pr = document.createElement('span'); pr.className = 'lt-pop__price'; pr.textContent = '+' + money(a.price) + (q(k) > 1 ? ' each · ' + q(k) + ' added' : ''); tt.appendChild(pr); }
      head.appendChild(tt);
      var x = document.createElement('button'); x.type = 'button'; x.className = 'lt-pop__close'; x.setAttribute('aria-label', 'Close'); x.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M2 2l8 8M10 2l-8 8" stroke="currentColor" stroke-width="1.6"/></svg>';
      x.addEventListener('click', function () { closePop(true); });
      head.appendChild(x);
      pop.appendChild(head);
      if (a.detail) { var d = document.createElement('p'); d.className = 'lt-pop__text'; d.textContent = a.detail; pop.appendChild(d); }
      var rm = document.createElement('button'); rm.type = 'button'; rm.className = 'lt-linkbtn lt-pop__remove'; rm.setAttribute('data-toggle', k); rm.textContent = 'Remove ' + a.title; pop.appendChild(rm);
      pop.setAttribute('aria-labelledby', h.id);
      var px = parseFloat(b.style.left), py = parseFloat(b.style.top);
      pop.style.left = px + '%'; pop.style.top = 'calc((100% - var(--lt-pad, 0px)) * ' + (py / 100) + ')';
      pop.className = 'lt-pop dir-' + (b.getAttribute('data-dir') || 'c') + ' ' + (py > 45 ? 'is-above' : 'is-below') + ' ' + (px < 30 ? 'is-l' : px > 70 ? 'is-r' : 'is-c');
      pop.hidden = false;
      b.setAttribute('aria-expanded', 'true'); b.classList.add('is-open');
      x.focus({ preventScroll: true });
    }
    if (pinsBox && pop) {
      pinsBox.addEventListener('click', function (e) {
        var b = e.target.closest('[data-pin]'); if (!b) return;
        var k = b.getAttribute('data-pin');
        if (openPin === k) closePop(false); else showPop(k);
      });
      document.addEventListener('click', function (e) { if (openPin && !pop.contains(e.target) && !e.target.closest('[data-pin]')) closePop(false); });
      root.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openPin) closePop(true); });
      var pinRender = render;
      render = function () {
        pinRender();
        pinsBox.querySelectorAll('[data-pin]').forEach(function (b) {
          var k = b.getAttribute('data-pin');
          var pos = ((on.canopy && b.getAttribute('data-pos-canopy')) || b.getAttribute('data-pos')).split(',');
          b.style.left = pos[0] + '%'; b.style.top = pos[1] + '%';
          var show = !!on[k] && !(k === 'drawers' && !hasDrawers);
          if (show && b.hidden) { b.hidden = false; b.classList.remove('is-new'); void b.offsetWidth; b.classList.add('is-new'); }
          if (!show) b.hidden = true;
        });
        if (openPin && !on[openPin]) closePop(false);
      };
    }
    // attachments / accessories tabs + "show accessories" photo
    var tabs = root.querySelectorAll('[data-tab]');
    function showTab(name, focus) {
      tabs.forEach(function (t) { var on_ = t.getAttribute('data-tab') === name; t.classList.toggle('is-on', on_); t.setAttribute('aria-selected', on_ ? 'true' : 'false'); t.tabIndex = on_ ? 0 : -1; if (on_ && focus) t.focus(); });
      root.querySelectorAll('[data-pane]').forEach(function (p) { p.hidden = p.getAttribute('data-pane') !== name; });
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { showTab(t.getAttribute('data-tab')); });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var list = Array.prototype.slice.call(tabs), i = list.indexOf(t), n = list[(i + (e.key === 'ArrowRight' ? 1 : list.length - 1)) % list.length];
        e.preventDefault(); showTab(n.getAttribute('data-tab'), true);
      });
    });
    var accBtn = root.querySelector('[data-show-acc]'), accShot = root.querySelector('[data-accshot]'), accView = false;
    var accLabel = accBtn && accBtn.querySelector('[data-show-acc-label]'), accLabelOff = accLabel ? accLabel.textContent : '';
    if (accBtn) accBtn.addEventListener('click', function () {
      if (!on.canopy) return;
      accView = !accView;
      if (accView) accShot.loading = 'eager';
      render();
    });
    // smiley on the silks: small Sarah's Silks brand card
    var silkPin = root.querySelector('[data-silk-pin]'), silkOpen = false;
    function closeSilk() { if (!silkOpen) return; silkOpen = false; silkPin.setAttribute('aria-expanded', 'false'); silkPin.classList.remove('is-open'); if (!openPin) { pop.hidden = true; pop.innerHTML = ''; } }
    if (silkPin && pop) {
      var sp = silkPin.getAttribute('data-pos').split(',');
      silkPin.style.left = sp[0] + '%'; silkPin.style.top = sp[1] + '%';
      silkPin.addEventListener('click', function (e) {
        e.stopPropagation();
        if (silkOpen) { closeSilk(); return; }
        if (openPin) closePop(false);
        silkOpen = true;
        pop.innerHTML = '';
        var head = document.createElement('div'); head.className = 'lt-pop__head';
        var lg = document.createElement('img'); lg.src = silkPin.getAttribute('data-logo'); lg.alt = "Sarah's Silks"; lg.className = 'lt-pop__logo'; head.appendChild(lg);
        var x = document.createElement('button'); x.type = 'button'; x.className = 'lt-pop__close'; x.setAttribute('aria-label', 'Close'); x.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M2 2l8 8M10 2l-8 8" stroke="currentColor" stroke-width="1.6"/></svg>';
        x.addEventListener('click', function () { closeSilk(); silkPin.focus(); }); head.appendChild(x); pop.appendChild(head);
        var t = document.createElement('p'); t.className = 'lt-pop__text'; t.textContent = silkPin.getAttribute('data-text'); pop.appendChild(t);
        var nt = silkPin.getAttribute('data-note'); if (nt) { var np = document.createElement('p'); np.className = 'lt-pop__note'; np.textContent = nt; pop.appendChild(np); }
        pop.setAttribute('aria-label', "About Sarah's Silks"); pop.removeAttribute('aria-labelledby');
        pop.style.left = sp[0] + '%'; pop.style.top = 'calc((100% - var(--lt-pad, 0px)) * ' + (parseFloat(sp[1]) / 100) + ')';
        pop.className = 'lt-pop dir-ul is-below is-l'; pop.hidden = false;
        silkPin.setAttribute('aria-expanded', 'true'); silkPin.classList.add('is-open');
        x.focus({ preventScroll: true });
      });
      document.addEventListener('click', function (e) { if (silkOpen && !pop.contains(e.target) && e.target !== silkPin) closeSilk(); });
      root.addEventListener('keydown', function (e) { if (e.key === 'Escape' && silkOpen) { closeSilk(); silkPin.focus(); } });
    }
    var accRender = render;
    render = function () {
      accRender();
      var cnt = (cfg.accessories || []).reduce(function (t, a) { return t + q(a.key); }, 0);
      var badge = root.querySelector('[data-acc-count]'); if (badge) { badge.hidden = !cnt; badge.textContent = cnt; }
      var hint = root.querySelector('[data-acc-hint]'); if (hint) hint.hidden = !!on.canopy;
      if (!accBtn) return;
      if (!on.canopy) accView = false;
      accBtn.disabled = !on.canopy;
      accBtn.title = on.canopy ? '' : 'Add The Canopy to see accessories';
      accBtn.setAttribute('aria-pressed', accView ? 'true' : 'false');
      accLabel.textContent = accView ? 'Hide accessories' : accLabelOff;
      accShot.classList.toggle('is-on', accView);
      if (silkPin) { var showS = accView && !!on.canopy; if (showS && silkPin.hidden) { silkPin.hidden = false; silkPin.classList.remove('is-new'); void silkPin.offsetWidth; silkPin.classList.add('is-new'); } if (!showS) { silkPin.hidden = true; closeSilk(); } }
    };
    // mobile sticky bar: shows while the main Add to cart button is off screen
    var mbar = root.querySelector('[data-mbar]');
    if (mbar) {
      root.querySelector('[data-mbar-add]').addEventListener('click', function () { addBtn.click(); addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
      if ('IntersectionObserver' in window) {
        var seen = { add: false, stage: true };
        var sync = function () { var show = !seen.add && !seen.stage; mbar.classList.toggle('is-show', show); mbar.setAttribute('aria-hidden', show ? 'false' : 'true'); mbar.querySelector('button').tabIndex = show ? 0 : -1; };
        new IntersectionObserver(function (es) { es.forEach(function (e) { seen.add = e.isIntersecting; }); sync(); }).observe(addBtn);
        var st = root.querySelector('[data-stage]');
        if (st) new IntersectionObserver(function (es) { es.forEach(function (e) { seen.stage = e.isIntersecting; }); sync(); }).observe(st);
      }
    }
    // "Click to Apply Discounts": shows the automatic discount's savings right in the panel
    var discBox = root.querySelector('[data-disc]'), discBtn = root.querySelector('[data-disc-btn]'), discOn = false;
    if (discBox && discBtn) {
      discBtn.addEventListener('click', function () { discOn = !discOn; render(); });
      var discRender = render;
      render = function () {
        discRender();
        var sum = root.__sum || 0, th = +discBox.getAttribute('data-threshold') || 0, pct = +discBox.getAttribute('data-pct') || 0;
        var line = discBox.querySelector('[data-disc-line]'), note = discBox.querySelector('[data-disc-note]'), lab = discBtn.querySelector('[data-disc-btn-label]');
        discBtn.setAttribute('aria-pressed', discOn ? 'true' : 'false');
        discBtn.classList.toggle('is-on', discOn);
        line.hidden = true; note.hidden = true;
        if (!discOn) { lab.textContent = 'Click to Apply Discounts'; return; }
        lab.textContent = 'Discounts applied';
        if (sum > 0 && sum >= th) {
          var off = Math.round(sum * pct / 100), nt = sum - off;
          line.hidden = false; discBox.querySelector('[data-disc-amt]').textContent = '−' + money(off);
          total.innerHTML = ''; var was = document.createElement('s'); was.className = 'lt-disc__was'; was.textContent = money(sum); total.appendChild(was); total.appendChild(document.createTextNode(' ' + money(nt)));
          var mt2 = root.querySelector('[data-mbar-total]'); if (mt2) mt2.textContent = money(nt);
          addBtn.textContent = 'Add to cart · ' + money(nt);
        } else {
          note.hidden = false;
          note.textContent = sum > 0 ? 'Add ' + money(th - sum) + ' more to save ' + pct + '% on your order.' : 'Build your Frame to see your savings.';
        }
      };
    }
    render();
  }
  function boot() { document.querySelectorAll('[data-configurator]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
